import * as types from './actions';

export const initialState = {
  type1: false,
  type2: false,
  step: 1,
  uploaded: [],
  loading: false,
  progress: 0,
  done: false
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.FILE_TYPE_SELECT:
      return { ...state, [`type${state.step}`]: payload.type };
    case types.FILE_STEP:
      return { ...state, step: state.step + 1 };
    case types.FILE_LIST_SAVE:
      return { ...state, uploaded: payload.uploaded };
    case types.FILE_UPLOADING:
      return { ...state, loading: !state.loading };
    case types.FILE_PROGRESS:
      return { ...state, progress: payload.progress };
    case types.FILE_UPLOADED:
      return {
        ...state, done: !state.done, loading: payload.loading, progress: 0
      };
    case 'RESET_STORE':
      return { ...state, ...initialState };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/pages/Upload/reducer.js